import axios from 'axios';
import qs from "qs";

export default {
  my_operations: (number) => (
    axios.get(`operations/active?pageSize=${number}`)
  ),
  operation_label: () => (
      axios.get(`operation_label`)
  ),
  my_participations: (params) => (
    axios.get(`participations`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    })
  ),
  is_signed: (ope, user) => (
    axios.get(`signatures/operation=${ope};customer=${user}`)
  ),
  sign_operation: (ope, cust, params) => (
    axios.put(`signatures/operation=${ope};customer=${cust}/sign`, params)
  ),
  send_code: (params) => (
    axios.post(`signatures/send-code`, params)
  )
}



// WEBPACK FOOTER //
// ./src/api/operations.js